import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  class: "spinner-grow text-danger",
  style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
  role: "status"
}
const _hoisted_3 = { class: "visually-hidden" }
const _hoisted_4 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing",
  id: "back"
}
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 flex-wrap gap-10" }
const _hoisted_6 = { class: "d-sm-flex flex-wrap align-items-center w-100 w-lg-30" }
const _hoisted_7 = { class: "d-sm-flex align-items-center" }
const _hoisted_8 = { class: "search-box-area position-relative me-sm-10 mt-10 mt-sm-0" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = {
  id: "",
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "d-flex align-items-center fs-md-15 fs-lg-16" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-secondary",
  role: "status"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 2,
  class: "text-body-tertiary"
}
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_26 = {
  key: 0,
  class: "fs-6 fw-bold text-black"
}
const _hoisted_27 = {
  key: 1,
  class: "text-body-tertiary"
}
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = ["onClick", "title"]
const _hoisted_30 = { class: "badge text-outline-primary" }
const _hoisted_31 = {
  key: 1,
  class: "text-body-tertiary"
}
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_35 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_36 = {
  key: 2,
  class: "badge text-outline-info"
}
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  colspan: "6",
  class: "text-center text-body-tertiary py-25"
}
const _hoisted_41 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_42 = { class: "mb-0 text-paragraph" }
const _hoisted_43 = { class: "fw-bold" }
const _hoisted_44 = { class: "mt-15 mt-md-0" }
const _hoisted_45 = { class: "pagination mb-0" }
const _hoisted_46 = {
  key: 0,
  class: "page-item"
}
const _hoisted_47 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 1,
  class: "page-item"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = {
  class: "modal fade",
  id: "createMerchantModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_55 = { class: "modal-content create-merchant-modal-content" }
const _hoisted_56 = { class: "modal-header" }
const _hoisted_57 = { class: "modal-title fs-5" }
const _hoisted_58 = { class: "modal-body" }
const _hoisted_59 = {
  key: 0,
  class: "mb-15"
}
const _hoisted_60 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_61 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_62 = { class: "create-org-search position-relative mb-15" }
const _hoisted_63 = ["placeholder"]
const _hoisted_64 = { class: "create-org-list" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "create-org-block-info" }
const _hoisted_67 = { class: "create-org-block-name" }
const _hoisted_68 = {
  key: 0,
  class: "create-org-block-sub"
}
const _hoisted_69 = {
  key: 0,
  class: "text-center text-body-tertiary py-20"
}
const _hoisted_70 = {
  key: 1,
  class: "text-center py-20"
}
const _hoisted_71 = {
  key: 2,
  class: "text-center pt-10"
}
const _hoisted_72 = { class: "modal-footer" }
const _hoisted_73 = {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_74 = ["disabled"]
const _hoisted_75 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_76 = { style: {"color":"#FFF"} }
const _hoisted_77 = {
  class: "modal fade",
  id: "otherAccountsModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_78 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_79 = { class: "modal-content" }
const _hoisted_80 = { class: "modal-header" }
const _hoisted_81 = { class: "modal-title fs-5" }
const _hoisted_82 = { class: "modal-body" }
const _hoisted_83 = { class: "table-responsive" }
const _hoisted_84 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_85 = { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0" }
const _hoisted_86 = { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }
const _hoisted_87 = { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }
const _hoisted_88 = { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }
const _hoisted_89 = { class: "fw-medium" }
const _hoisted_90 = { class: "badge text-outline-primary" }
const _hoisted_91 = { class: "fw-medium" }
const _hoisted_92 = { class: "fw-medium" }
const _hoisted_93 = { class: "fw-medium" }
const _hoisted_94 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_95 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_96 = {
  key: 2,
  class: "badge text-outline-info"
}
const _hoisted_97 = { class: "modal-footer" }
const _hoisted_98 = {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_99 = {
  class: "modal fade",
  id: "viewOrgModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_100 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_101 = { class: "modal-content" }
const _hoisted_102 = { class: "modal-header" }
const _hoisted_103 = { class: "modal-title fs-5" }
const _hoisted_104 = { class: "modal-body" }
const _hoisted_105 = { class: "fw-bold mb-15" }
const _hoisted_106 = { class: "row g-3 mb-25" }
const _hoisted_107 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_108 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_109 = ["value"]
const _hoisted_110 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_111 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_112 = ["value"]
const _hoisted_113 = {
  key: 2,
  class: "col-12 col-md-4"
}
const _hoisted_114 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_115 = ["value"]
const _hoisted_116 = {
  key: 3,
  class: "col-12 col-md-4"
}
const _hoisted_117 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_118 = ["value"]
const _hoisted_119 = {
  key: 4,
  class: "col-12 col-md-4"
}
const _hoisted_120 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_121 = ["value"]
const _hoisted_122 = {
  key: 5,
  class: "col-12 col-md-4"
}
const _hoisted_123 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_124 = ["value"]
const _hoisted_125 = {
  key: 6,
  class: "col-12 col-md-4"
}
const _hoisted_126 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_127 = ["value"]
const _hoisted_128 = {
  key: 7,
  class: "col-12 col-md-4"
}
const _hoisted_129 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_130 = ["value"]
const _hoisted_131 = {
  key: 8,
  class: "col-12 col-md-4"
}
const _hoisted_132 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_133 = ["value"]
const _hoisted_134 = { class: "fw-bold mb-15" }
const _hoisted_135 = { class: "table-responsive" }
const _hoisted_136 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_137 = { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0" }
const _hoisted_138 = { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }
const _hoisted_139 = { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }
const _hoisted_140 = { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }
const _hoisted_141 = { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }
const _hoisted_142 = { class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" }
const _hoisted_143 = { class: "fw-medium" }
const _hoisted_144 = { class: "badge text-outline-primary" }
const _hoisted_145 = { class: "fw-medium" }
const _hoisted_146 = { class: "fw-medium" }
const _hoisted_147 = { class: "fw-medium" }
const _hoisted_148 = { class: "fw-medium" }
const _hoisted_149 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_150 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_151 = {
  key: 2,
  class: "badge text-outline-info"
}
const _hoisted_152 = { class: "fw-medium" }
const _hoisted_153 = { class: "modal-footer" }
const _hoisted_154 = {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_155 = {
  class: "modal fade",
  id: "editMerchantModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_156 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_157 = { class: "modal-content" }
const _hoisted_158 = { class: "modal-header" }
const _hoisted_159 = { class: "modal-title fs-5" }
const _hoisted_160 = { class: "modal-body" }
const _hoisted_161 = {
  key: 0,
  class: "mb-15"
}
const _hoisted_162 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_163 = { class: "form-group mb-20" }
const _hoisted_164 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_165 = { value: "" }
const _hoisted_166 = ["value"]
const _hoisted_167 = {
  key: 1,
  class: "row g-3"
}
const _hoisted_168 = { class: "col-12 col-md-6" }
const _hoisted_169 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_170 = { class: "col-12 col-md-6" }
const _hoisted_171 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_172 = { class: "col-12 col-md-4" }
const _hoisted_173 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_174 = { class: "col-12 col-md-4" }
const _hoisted_175 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_176 = {
  class: "col-12 col-md-4 d-flex align-items-center",
  style: {"padding-top":"32px"}
}
const _hoisted_177 = { class: "form-check" }
const _hoisted_178 = {
  class: "form-check-label fw-semibold",
  for: "trackBalanceCheck"
}
const _hoisted_179 = { class: "modal-footer" }
const _hoisted_180 = {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_181 = ["disabled"]
const _hoisted_182 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_183 = { style: {"color":"#FFF"} }
const _hoisted_184 = {
  class: "modal fade",
  id: "changeMerchantStatusModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_185 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_186 = { class: "modal-content edit-status-modal-content" }
const _hoisted_187 = { class: "edit-status-header" }
const _hoisted_188 = { class: "mb-0 mt-10" }
const _hoisted_189 = { class: "text-muted fs-13 mb-0 mt-5" }
const _hoisted_190 = { class: "modal-body pt-10" }
const _hoisted_191 = { class: "form-group mb-15" }
const _hoisted_192 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_193 = { value: "" }
const _hoisted_194 = ["value"]
const _hoisted_195 = {
  key: 0,
  class: "form-group mb-15"
}
const _hoisted_196 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_197 = {
  key: 1,
  class: "text-danger fs-13 mt-10 mb-0"
}
const _hoisted_198 = {
  key: 0,
  class: "modal-footer border-0 pt-0"
}
const _hoisted_199 = {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_200 = ["disabled"]
const _hoisted_201 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_202 = { style: {"color":"#FFF"} }

import { ref, reactive, onMounted, onBeforeUnmount, inject, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import axios from 'axios';
import { Modal } from 'bootstrap';

import router from '../../../router/index';
import { current_permissions } from '../../../utils/permission';
import { showToast, checkSessionValidate } from "@/utils/function";

declare interface Organization {
  code: string;
  name: string;
  description?: string;
  contact?: string;
  status?: string;
  email?: string;
  bankDomiciliation?: string;
  rib?: string;
  cryptoAccount?: string;
  type?: string;
  createdAt?: string;
  updatedAt?: string | null;
}

declare interface Merchant {
  code: string;
  name: string;
  description: string;
  status: string;
  type: string;
  merchantAccountType: string;
  providerBalanceType: string | null;
  trackBalance: boolean;
  user: any;
  organization: { code: string; name: string } | null;
  provider: any;
  operator: any;
  ledgerAccountBalance: { code: string; balance: number; blockedBalance: string } | null;
  createdAt: string;
  updatedAt: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LedgerAccount',
  setup(__props) {

const { t } = useI18n();

const backApi = inject('back');
const token = localStorage.getItem('login_token');

const merchantsUrl = backApi + '/secure/merchants/extended';
const organizationsUrl = backApi + '/secure/organizations';

const loader = ref(false);

// ═══ Liste des organisations (ligne = organisation) ═══
const organizationsList = ref(new Array<Organization>());
const orgPage = ref(1);
const orgTotal = ref(0);
const orgNumPages = ref(1);
const searchQuery = ref('');

// Comptes marchands par organisation (cache)
const merchantsByOrg = reactive<Record<string, Merchant[]>>({});
const merchantsLoading = reactive<Record<string, boolean>>({});

function getAllAccounts(code: string): Merchant[] {
  return merchantsByOrg[code] || [];
}
function getMainAccount(code: string): Merchant | undefined {
  return getAllAccounts(code).find((m) => m.merchantAccountType === 'MAIN');
}
function getOtherAccounts(code: string): Merchant[] {
  return getAllAccounts(code).filter((m) => m.merchantAccountType !== 'MAIN');
}

const hasValue = (value: any): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '' || trimmed === 'null' || trimmed === 'undefined') return false;
  }
  return true;
};

// ✅ Formatage des montants avec espace comme séparateur de milliers
function formatAmount(value: any): string {
  const num = Number(value || 0);
  if (isNaN(num)) return '0';
  // toLocaleString('fr-FR') utilise des espaces insécables ; on les remplace par des espaces normales
  return num.toLocaleString('fr-FR').replace(/\u202f/g, ' ').replace(/\u00a0/g, ' ');
}

function formatDateTimeFr(value: string | null | undefined) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

function handleAxiosError(error: any, fallback = t('merchants.error_occurred')) {
  if (error.response) {
    if (error.response.status === 401) {
      router.push('/');
    } else {
      showToast(error.response.data?.message ?? fallback, "red");
    }
  }
}

async function fetchMerchantsForOrg(code: string) {
  merchantsLoading[code] = true;
  try {
    const response = await axios.get(`${merchantsUrl}?organization=${code}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    merchantsByOrg[code] = response.data.data ?? response.data ?? [];
  } catch (error) {
    merchantsByOrg[code] = [];
  } finally {
    merchantsLoading[code] = false;
  }
}

async function fetchOrganizations(pageArg = 1, search = '') {
  loader.value = false;
  try {
    const searchParam = search ? `?organization=${encodeURIComponent(search)}` : '';
    const response = await axios.get(`${organizationsUrl}/${pageArg}${searchParam}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    organizationsList.value = response.data.organizations || [];
    orgPage.value = pageArg;
    orgTotal.value = parseInt(response.data.pagination?.total ?? organizationsList.value.length);
    orgNumPages.value = parseInt(response.data.pagination?.numPages ?? 1);
    loader.value = true;

    await Promise.all(organizationsList.value.map((org) => fetchMerchantsForOrg(org.code)));
  } catch (error) {
    loader.value = true;
    handleAxiosError(error, t('merchants.error_loading_organizations'));
  }
}

function searchOrganizations() {
  fetchOrganizations(1, searchQuery.value);
}

// ═══ Organisations pour le modal Créer (liste indépendante, paginée à la demande) ═══
const createOrgList = ref(new Array<Organization>());
const createOrgLoading = ref(false);
const createOrgPage = ref(1);
const createOrgPagesLeft = ref(0);
const createOrgSearch = ref('');

async function fetchCreateOrganizations(pageArg = 1, append = false, search = '') {
  createOrgLoading.value = true;
  try {
    const searchParam = search ? `?organization=${encodeURIComponent(search)}` : '';
    const response = await axios.get(`${organizationsUrl}/${pageArg}${searchParam}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const rawList: Organization[] = response.data.organizations || [];
    createOrgPage.value = pageArg;
    createOrgPagesLeft.value = response.data.pagination?.pagesLeft ?? 0;

    // On exclut les organisations qui ont déjà des comptes marchands
    const checks = await Promise.all(rawList.map(async (org) => {
      try {
        const r = await axios.get(`${merchantsUrl}?organization=${org.code}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const accounts = r.data.data ?? r.data ?? [];
        return { org, hasAccounts: accounts.length > 0 };
      } catch {
        return { org, hasAccounts: false };
      }
    }));
    const withoutAccounts = checks.filter((c) => !c.hasAccounts).map((c) => c.org);

    createOrgList.value = append ? createOrgList.value.concat(withoutAccounts) : withoutAccounts;
  } catch (error) {
    handleAxiosError(error, t('merchants.error_loading_organizations'));
  } finally {
    createOrgLoading.value = false;
  }
}

function loadMoreCreateOrganizations() {
  fetchCreateOrganizations(createOrgPage.value + 1, true, createOrgSearch.value);
}

function searchCreateOrganizations() {
  fetchCreateOrganizations(1, false, createOrgSearch.value);
}

const selectedCreateOrganization = ref('');
const btnLoadCreate = ref(true);
const createError = ref('');

function openCreateModal() {
  createError.value = '';
  selectedCreateOrganization.value = '';
  createOrgSearch.value = '';
  fetchCreateOrganizations(1, false, '');
}

function submitCreateMerchant() {
  if (!selectedCreateOrganization.value) {
    createError.value = t('merchants.please_select_organization');
    return;
  }
  createError.value = '';
  btnLoadCreate.value = false;

  axios.post(`${backApi}/secure/merchants/all`, {
    organization: selectedCreateOrganization.value,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then(() => {
    btnLoadCreate.value = true;
    showToast(t('merchants.merchant_accounts_created'), "green");
    const modalEl = document.getElementById('createMerchantModal');
    if (modalEl) Modal.getInstance(modalEl)?.hide();
    fetchOrganizations(orgPage.value, searchQuery.value);
  }).catch((error) => {
    btnLoadCreate.value = true;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        createError.value = error.response.data?.message ?? t('merchants.error_occurred');
      }
    }
  });
}

// ═══ Modal Autres comptes ═══
const currentOrgForOthers = ref<Organization | null>(null);
const currentOrgOtherAccounts = ref(new Array<Merchant>());

function handleShowOtherAccounts(org: Organization) {
  currentOrgForOthers.value = org;
  currentOrgOtherAccounts.value = getOtherAccounts(org.code);
  const modalEl = document.getElementById('otherAccountsModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();
}

// ═══ Modal Voir : organisation + tous les comptes ═══
const currentViewOrg = ref<Organization | null>(null);
const currentViewAccounts = ref(new Array<Merchant>());

function handleView(orgCode: string) {
  const org = organizationsList.value.find((o) => o.code === orgCode);
  if (!org) {
    closeActionMenu();
    return;
  }
  currentViewOrg.value = org;
  currentViewAccounts.value = getAllAccounts(org.code);
  closeActionMenu();
  const modalEl = document.getElementById('viewOrgModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();
}

// ═══ Modal Modifier : choix du compte puis formulaire ═══
const currentOrgForEdit = ref<Organization | null>(null);
const editAccounts = ref(new Array<Merchant>());
const selectedEditAccountCode = ref('');
const editForm = ref({
  name: '',
  description: '',
  status: 'ACTIVE',
  type: 'merchant_account',
  merchantAccountType: 'MAIN',
});
const btnLoadEdit = ref(true);
const editError = ref('');

function handleEdit(orgCode: string) {
  const org = organizationsList.value.find((o) => o.code === orgCode);
  if (!org) {
    closeActionMenu();
    return;
  }
  currentOrgForEdit.value = org;
  editAccounts.value = getAllAccounts(org.code);
  selectedEditAccountCode.value = '';
  editError.value = '';
  closeActionMenu();
  const modalEl = document.getElementById('editMerchantModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();
}

function onSelectEditAccount() {
  const acc = editAccounts.value.find((a) => a.code === selectedEditAccountCode.value);
  if (!acc) return;
  editForm.value = {
    name: acc.name ?? '',
    description: acc.description ?? '',
    status: acc.status ?? 'ACTIVE',
    type: acc.type ?? 'merchant_account',
    merchantAccountType: acc.merchantAccountType ?? 'MAIN',
  };
}

function submitEditMerchant() {
  if (!selectedEditAccountCode.value || !currentOrgForEdit.value) return;
  editError.value = '';
  btnLoadEdit.value = false;

  const payload = {
    name: editForm.value.name,
    description: editForm.value.description,
    status: editForm.value.status,
    type: editForm.value.type,
    merchantAccountType: editForm.value.merchantAccountType,
    providerBalanceType: null,
    trackBalance: (editAccounts.value.find(a => a.code === selectedEditAccountCode.value))?.trackBalance ?? true,
    user: null,
    organization: currentOrgForEdit.value.code,
    provider: null,
    operator: null,
  };

  axios.put(`${backApi}/secure/merchants/${selectedEditAccountCode.value}/edit`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then(() => {
    btnLoadEdit.value = true;
    showToast(t('merchants.merchant_account_updated'), "green");
    const modalEl = document.getElementById('editMerchantModal');
    if (modalEl) Modal.getInstance(modalEl)?.hide();
    if (currentOrgForEdit.value) fetchMerchantsForOrg(currentOrgForEdit.value.code);
  }).catch((error) => {
    btnLoadEdit.value = true;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        editError.value = error.response.data?.message ?? t('merchants.error_occurred');
      }
    }
  });
}

// ═══ Modal Changer le statut : choix du compte puis statut ═══
const currentOrgForStatus = ref<Organization | null>(null);
const statusAccounts = ref(new Array<Merchant>());
const selectedStatusAccountCode = ref('');
const newStatusValue = ref('ACTIVE');
const btnLoadStatus = ref(true);
const statusError = ref('');

function handleChangeStatus(orgCode: string) {
  const org = organizationsList.value.find((o) => o.code === orgCode);
  if (!org) {
    closeActionMenu();
    return;
  }
  currentOrgForStatus.value = org;
  statusAccounts.value = getAllAccounts(org.code);
  selectedStatusAccountCode.value = '';
  newStatusValue.value = 'ACTIVE';
  statusError.value = '';
  closeActionMenu();
  const modalEl = document.getElementById('changeMerchantStatusModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();
}

function onSelectStatusAccount() {
  const acc = statusAccounts.value.find((a) => a.code === selectedStatusAccountCode.value);
  if (acc) newStatusValue.value = acc.status ?? 'ACTIVE';
}

function submitChangeStatus() {
  statusError.value = '';

  if (!selectedStatusAccountCode.value) {
    statusError.value = t('merchants.please_select_account');
    return;
  }

  btnLoadStatus.value = false;

  axios.put(`${backApi}/secure/merchants/status/${selectedStatusAccountCode.value}`, {
    status: newStatusValue.value,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then(() => {
    btnLoadStatus.value = true;
    showToast(t('merchants.status_updated'), "green");
    const modalEl = document.getElementById('changeMerchantStatusModal');
    if (modalEl) Modal.getInstance(modalEl)?.hide();
    if (currentOrgForStatus.value) fetchMerchantsForOrg(currentOrgForStatus.value.code);
  }).catch((error) => {
    btnLoadStatus.value = true;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        statusError.value = error.response.data?.message ?? t('merchants.error_occurred');
        showToast(statusError.value, "red");
      }
    }
  });
}

// ═══ Menu d'actions flottant ═══
const openMenuId = ref<string | null>(null);
const menuPosition = ref({ top: 0, left: 0 });
let menuOpenedAt = 0;

function toggleActionMenu(event: MouseEvent, code: string) {
  if (openMenuId.value === code) {
    closeActionMenu();
    return;
  }

  const button = event.currentTarget as HTMLElement;
  const rect = button.getBoundingClientRect();
  const menuWidth = 200;

  let left = rect.right - menuWidth;
  if (left < 8) left = 8;
  if (left + menuWidth > window.innerWidth - 8) {
    left = window.innerWidth - menuWidth - 8;
  }

  menuPosition.value = { top: rect.bottom + 4, left };
  openMenuId.value = code;
  menuOpenedAt = Date.now();

  nextTick(() => {
    const menuEl = document.querySelector('.action-menu-fixed') as HTMLElement | null;
    if (!menuEl) return;
    const menuHeight = menuEl.offsetHeight;

    let top = rect.bottom + 4;
    if (top + menuHeight > window.innerHeight - 8) {
      top = rect.top - menuHeight - 4;
    }
    if (top < 8) top = 8;

    menuPosition.value = { ...menuPosition.value, top };
  });
}

function closeActionMenu() {
  openMenuId.value = null;
}

function handleGlobalClick(e: MouseEvent) {
  if (!openMenuId.value) return;
  const target = e.target as HTMLElement;
  if (target.closest('.action-menu-fixed') || target.closest('.dropdown-toggle')) {
    return;
  }
  closeActionMenu();
}

function handleGlobalScroll() {
  if (!openMenuId.value) return;
  if (Date.now() - menuOpenedAt < 300) return;
  closeActionMenu();
}

onMounted(() => {
  checkSessionValidate(1);
  fetchOrganizations();

  document.addEventListener('click', handleGlobalClick);
  document.addEventListener('scroll', handleGlobalScroll, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleGlobalClick);
  document.removeEventListener('scroll', handleGlobalScroll, true);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('merchants.loading')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_unref(current_permissions)('create_all_merchant_account'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn d-block text-center w-80 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#createMerchantModal",
                    onClick: openCreateModal
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('merchants.create')) + " ", 1),
                    _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 top-2 fs-15" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                  type: "text",
                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                  placeholder: _ctx.$t('merchants.search_organization'),
                  onKeyup: _withKeys(searchOrganizations, ["enter"])
                }, null, 40, _hoisted_9), [
                  [_vModelText, searchQuery.value]
                ])
              ]),
              _createElementVNode("button", {
                class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0",
                type: "button",
                onClick: searchOrganizations
              }, [...(_cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "flaticon-search-interface-symbol" }, null, -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('merchants.organization')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('merchants.main_account')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('merchants.main_balance')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('merchants.other_accounts')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('merchants.status')), 1),
                    _cache[19] || (_cache[19] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizationsList.value, (org) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: org.code
                    }, [
                      _createElementVNode("th", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(org.name), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_21, [
                        (merchantsLoading[org.code])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                          : (getMainAccount(org.code))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(getMainAccount(org.code)?.name), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_24, "—"))
                      ]),
                      _createElementVNode("td", _hoisted_25, [
                        (!merchantsLoading[org.code] && getMainAccount(org.code))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(formatAmount(getMainAccount(org.code)?.ledgerAccountBalance?.balance)), 1))
                          : (!merchantsLoading[org.code])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, " — "))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_28, [
                        (!merchantsLoading[org.code] && getOtherAccounts(org.code).length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "dot-btn lh-1 position-relative bg-transparent border-0 shadow-none p-0 transition d-inline-flex align-items-center",
                              onClick: ($event: any) => (handleShowOtherAccounts(org)),
                              title: _ctx.$t('merchants.view_other_accounts', { count: getOtherAccounts(org.code).length })
                            }, [
                              _cache[20] || (_cache[20] = _createElementVNode("i", { class: "flaticon-view fs-16 me-5" }, null, -1)),
                              _createElementVNode("span", _hoisted_30, _toDisplayString(getOtherAccounts(org.code).length), 1)
                            ], 8, _hoisted_29))
                          : (!merchantsLoading[org.code])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, "—"))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_32, [
                        (!merchantsLoading[org.code] && getMainAccount(org.code))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                              (getMainAccount(org.code)?.status==='ACTIVE')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('merchants.active')), 1))
                                : (getMainAccount(org.code)?.status==='INACTIVE')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('merchants.inactive')), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(getMainAccount(org.code)?.status), 1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_37, [
                        _createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          onClick: ($event: any) => (toggleActionMenu($event, org.code))
                        }, [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("i", { class: "flaticon-dots" }, null, -1)
                        ]))], 8, _hoisted_38)
                      ])
                    ]))
                  }), 128)),
                  (!organizationsList.value.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                        _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.$t('merchants.no_organization')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (orgTotal.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("p", _hoisted_42, [
                    _createTextVNode(_toDisplayString(_ctx.$t('merchants.showing', { count: organizationsList.value.length })) + " ", 1),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(orgTotal.value), 1)
                  ]),
                  _createElementVNode("nav", _hoisted_44, [
                    _createElementVNode("ul", _hoisted_45, [
                      ((orgPage.value-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchOrganizations(orgPage.value-1, searchQuery.value))),
                              "aria-label": "Previous"
                            }, [...(_cache[22] || (_cache[22] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orgNumPages.value, (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==orgPage.value)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_47, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (fetchOrganizations(numPage, searchQuery.value))
                              }, _toDisplayString(numPage), 9, _hoisted_48))
                        ]))
                      }), 128)),
                      ((orgPage.value+1)<=orgNumPages.value)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchOrganizations(orgPage.value+1, searchQuery.value))),
                              "aria-label": "Next"
                            }, [...(_cache[23] || (_cache[23] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (openMenuId.value)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 0,
            class: "dropdown-menu show action-menu-fixed",
            style: _normalizeStyle({ top: menuPosition.value.top + 'px', left: menuPosition.value.left + 'px' }),
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_unref(current_permissions)('list_ledger_accounts'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_50, [
                  _createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (handleView(openMenuId.value))),
                    href: "javascript:void(0);",
                    class: "dropdown-item d-flex align-items-center"
                  }, [
                    _cache[24] || (_cache[24] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('merchants.view')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(current_permissions)('update_ledger_account'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (handleEdit(openMenuId.value))),
                    href: "javascript:void(0);",
                    class: "dropdown-item d-flex align-items-center"
                  }, [
                    _cache[25] || (_cache[25] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('merchants.edit')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(current_permissions)('merchant_account_status'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (handleChangeStatus(openMenuId.value))),
                    href: "javascript:void(0);",
                    class: "dropdown-item d-flex align-items-center"
                  }, [
                    _cache[26] || (_cache[26] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('merchants.change_status')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 4))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitCreateMerchant, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("h1", _hoisted_57, _toDisplayString(_ctx.$t('merchants.create_merchant_accounts')), 1),
              _cache[27] || (_cache[27] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_58, [
              (createError.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("h6", _hoisted_60, _toDisplayString(createError.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('merchants.organization')), 1),
              _createElementVNode("div", _hoisted_62, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((createOrgSearch).value = $event)),
                  type: "text",
                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16 ps-40",
                  placeholder: _ctx.$t('merchants.search_organization'),
                  onKeyup: _withKeys(searchCreateOrganizations, ["enter"])
                }, null, 40, _hoisted_63), [
                  [_vModelText, createOrgSearch.value]
                ]),
                _cache[28] || (_cache[28] = _createElementVNode("i", { class: "flaticon-search-interface-symbol create-org-search-icon" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_64, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(createOrgList.value, (org) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: org.code,
                    class: _normalizeClass(["create-org-block", { active: selectedCreateOrganization.value === org.code }]),
                    onClick: ($event: any) => (selectedCreateOrganization.value = org.code)
                  }, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "create-org-block-radio" }, [
                      _createElementVNode("span", { class: "create-org-block-radio-dot" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("span", _hoisted_67, _toDisplayString(org.name), 1),
                      (org.email)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(org.email), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_65))
                }), 128)),
                (!createOrgLoading.value && !createOrgList.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.$t('merchants.no_organization')), 1))
                  : _createCommentVNode("", true),
                (createOrgLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [...(_cache[30] || (_cache[30] = [
                      _createElementVNode("span", {
                        class: "spinner-border spinner-border-sm text-secondary",
                        role: "status"
                      }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (!createOrgLoading.value && createOrgPagesLeft.value>0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link p-0 fs-13",
                        onClick: loadMoreCreateOrganizations
                      }, _toDisplayString(_ctx.$t('merchants.load_more_organizations')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("button", _hoisted_73, _toDisplayString(_ctx.$t('merchants.cancel')), 1),
              _createElementVNode("button", {
                type: "submit",
                disabled: !btnLoadCreate.value || !selectedCreateOrganization.value,
                class: "btn text-white",
                style: {"background-color":"#EB9355"}
              }, [
                (!btnLoadCreate.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_75))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.$t('merchants.create')), 1)
              ], 8, _hoisted_74)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_77, [
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("h1", _hoisted_81, _toDisplayString(_ctx.$t('merchants.other_accounts_title')) + " — " + _toDisplayString(currentOrgForOthers.value?.name), 1),
            _cache[31] || (_cache[31] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("table", _hoisted_84, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_85, _toDisplayString(_ctx.$t('merchants.type')), 1),
                    _createElementVNode("th", _hoisted_86, _toDisplayString(_ctx.$t('merchants.balance')), 1),
                    _createElementVNode("th", _hoisted_87, _toDisplayString(_ctx.$t('merchants.blocked_balance')), 1),
                    _createElementVNode("th", _hoisted_88, _toDisplayString(_ctx.$t('merchants.status')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentOrgOtherAccounts.value, (acc) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: acc.code
                    }, [
                      _createElementVNode("td", _hoisted_89, [
                        _createElementVNode("span", _hoisted_90, _toDisplayString(acc.merchantAccountType), 1)
                      ]),
                      _createElementVNode("td", _hoisted_91, _toDisplayString(formatAmount(acc.ledgerAccountBalance?.balance)), 1),
                      _createElementVNode("td", _hoisted_92, _toDisplayString(formatAmount(acc.ledgerAccountBalance?.blockedBalance)), 1),
                      _createElementVNode("td", _hoisted_93, [
                        (acc.status==='ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(_ctx.$t('merchants.active')), 1))
                          : (acc.status==='INACTIVE')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_95, _toDisplayString(_ctx.$t('merchants.inactive')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(acc.status), 1))
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("button", _hoisted_98, _toDisplayString(_ctx.$t('merchants.close')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_99, [
      _createElementVNode("div", _hoisted_100, [
        _createElementVNode("div", _hoisted_101, [
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("h1", _hoisted_103, _toDisplayString(currentViewOrg.value?.name), 1),
            _cache[32] || (_cache[32] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("h6", _hoisted_105, _toDisplayString(_ctx.$t('merchants.organization_info')), 1),
            _createElementVNode("div", _hoisted_106, [
              (hasValue(currentViewOrg.value?.code))
                ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                    _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.$t('merchants.code')), 1),
                    _createElementVNode("input", {
                      value: currentViewOrg.value?.code,
                      type: "text",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      readonly: ""
                    }, null, 8, _hoisted_109)
                  ]))
                : _createCommentVNode("", true),
              (hasValue(currentViewOrg.value?.description))
                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                    _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.$t('merchants.description')), 1),
                    _createElementVNode("input", {
                      value: currentViewOrg.value?.description,
                      type: "text",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      readonly: ""
                    }, null, 8, _hoisted_112)
                  ]))
                : _createCommentVNode("", true),
              (hasValue(currentViewOrg.value?.status))
                ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                    _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.$t('merchants.organization_status')), 1),
                    _createElementVNode("input", {
                      value: currentViewOrg.value?.status,
                      type: "text",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      readonly: ""
                    }, null, 8, _hoisted_115)
                  ]))
                : _createCommentVNode("", true),
              (hasValue(currentViewOrg.value?.email))
                ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                    _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.$t('merchants.email')), 1),
                    _createElementVNode("input", {
                      value: currentViewOrg.value?.email,
                      type: "text",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      readonly: ""
                    }, null, 8, _hoisted_118)
                  ]))
                : _createCommentVNode("", true),
              (hasValue(currentViewOrg.value?.contact))
                ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                    _createElementVNode("label", _hoisted_120, _toDisplayString(_ctx.$t('merchants.contact')), 1),
                    _createElementVNode("input", {
                      value: currentViewOrg.value?.contact,
                      type: "text",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      readonly: ""
                    }, null, 8, _hoisted_121)
                  ]))
                : _createCommentVNode("", true),
              (hasValue(currentViewOrg.value?.type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                    _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.$t('merchants.type')), 1),
                    _createElementVNode("input", {
                      value: currentViewOrg.value?.type,
                      type: "text",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      readonly: ""
                    }, null, 8, _hoisted_124)
                  ]))
                : _createCommentVNode("", true),
              (hasValue(currentViewOrg.value?.bankDomiciliation))
                ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                    _createElementVNode("label", _hoisted_126, _toDisplayString(_ctx.$t('merchants.bank_domiciliation')), 1),
                    _createElementVNode("input", {
                      value: currentViewOrg.value?.bankDomiciliation,
                      type: "text",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      readonly: ""
                    }, null, 8, _hoisted_127)
                  ]))
                : _createCommentVNode("", true),
              (hasValue(currentViewOrg.value?.rib))
                ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                    _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.$t('merchants.rib')), 1),
                    _createElementVNode("input", {
                      value: currentViewOrg.value?.rib,
                      type: "text",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      readonly: ""
                    }, null, 8, _hoisted_130)
                  ]))
                : _createCommentVNode("", true),
              (hasValue(currentViewOrg.value?.createdAt))
                ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                    _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.$t('merchants.created_on')), 1),
                    _createElementVNode("input", {
                      value: formatDateTimeFr(currentViewOrg.value?.createdAt),
                      type: "text",
                      class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      readonly: ""
                    }, null, 8, _hoisted_133)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("h6", _hoisted_134, _toDisplayString(_ctx.$t('merchants.organization_accounts')), 1),
            _createElementVNode("div", _hoisted_135, [
              _createElementVNode("table", _hoisted_136, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_137, _toDisplayString(_ctx.$t('merchants.type')), 1),
                    _createElementVNode("th", _hoisted_138, _toDisplayString(_ctx.$t('merchants.balance')), 1),
                    _createElementVNode("th", _hoisted_139, _toDisplayString(_ctx.$t('merchants.blocked_balance')), 1),
                    _createElementVNode("th", _hoisted_140, _toDisplayString(_ctx.$t('merchants.track_balance')), 1),
                    _createElementVNode("th", _hoisted_141, _toDisplayString(_ctx.$t('merchants.status')), 1),
                    _createElementVNode("th", _hoisted_142, _toDisplayString(_ctx.$t('merchants.created_at')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentViewAccounts.value, (acc) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: acc.code
                    }, [
                      _createElementVNode("td", _hoisted_143, [
                        _createElementVNode("span", _hoisted_144, _toDisplayString(acc.merchantAccountType), 1)
                      ]),
                      _createElementVNode("td", _hoisted_145, _toDisplayString(formatAmount(acc.ledgerAccountBalance?.balance)), 1),
                      _createElementVNode("td", _hoisted_146, _toDisplayString(formatAmount(acc.ledgerAccountBalance?.blockedBalance)), 1),
                      _createElementVNode("td", _hoisted_147, _toDisplayString(acc.trackBalance ? _ctx.$t('merchants.yes') : _ctx.$t('merchants.no')), 1),
                      _createElementVNode("td", _hoisted_148, [
                        (acc.status==='ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_149, _toDisplayString(_ctx.$t('merchants.active')), 1))
                          : (acc.status==='INACTIVE')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_150, _toDisplayString(_ctx.$t('merchants.inactive')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_151, _toDisplayString(acc.status), 1))
                      ]),
                      _createElementVNode("td", _hoisted_152, _toDisplayString(formatDateTimeFr(acc.createdAt)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_153, [
            _createElementVNode("button", _hoisted_154, _toDisplayString(_ctx.$t('merchants.close')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_155, [
      _createElementVNode("div", _hoisted_156, [
        _createElementVNode("div", _hoisted_157, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitEditMerchant, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("h1", _hoisted_159, _toDisplayString(_ctx.$t('merchants.edit_account')) + " — " + _toDisplayString(currentOrgForEdit.value?.name), 1),
              _cache[33] || (_cache[33] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_160, [
              (editError.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                    _createElementVNode("h6", _hoisted_162, _toDisplayString(editError.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("label", _hoisted_164, _toDisplayString(_ctx.$t('merchants.account_to_edit')), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedEditAccountCode).value = $event)),
                  class: "form-select fs-md-15 text-black shadow-none",
                  onChange: onSelectEditAccount,
                  required: ""
                }, [
                  _createElementVNode("option", _hoisted_165, _toDisplayString(_ctx.$t('merchants.select_account')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editAccounts.value, (acc) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: acc.code,
                      key: acc.code
                    }, _toDisplayString(acc.merchantAccountType), 9, _hoisted_166))
                  }), 128))
                ], 544), [
                  [_vModelSelect, selectedEditAccountCode.value]
                ])
              ]),
              (selectedEditAccountCode.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                    _createElementVNode("div", _hoisted_168, [
                      _createElementVNode("label", _hoisted_169, _toDisplayString(_ctx.$t('merchants.name')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editForm.value.name) = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        required: ""
                      }, null, 512), [
                        [_vModelText, editForm.value.name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_170, [
                      _createElementVNode("label", _hoisted_171, _toDisplayString(_ctx.$t('merchants.description')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editForm.value.description) = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, editForm.value.description]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("label", _hoisted_173, _toDisplayString(_ctx.$t('merchants.account_type')), 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editForm.value.merchantAccountType) = $event)),
                        class: "form-select fs-md-15 text-black shadow-none",
                        required: ""
                      }, [...(_cache[34] || (_cache[34] = [
                        _createElementVNode("option", { value: "MAIN" }, "MAIN", -1),
                        _createElementVNode("option", { value: "COLLECT" }, "COLLECT", -1),
                        _createElementVNode("option", { value: "AVAILABLE" }, "AVAILABLE", -1),
                        _createElementVNode("option", { value: "PAYOUT" }, "PAYOUT", -1)
                      ]))], 512), [
                        [_vModelSelect, editForm.value.merchantAccountType]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("label", _hoisted_175, _toDisplayString(_ctx.$t('merchants.status')), 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editForm.value.status) = $event)),
                        class: "form-select fs-md-15 text-black shadow-none",
                        required: ""
                      }, [...(_cache[35] || (_cache[35] = [
                        _createElementVNode("option", { value: "ACTIVE" }, "ACTIVE", -1),
                        _createElementVNode("option", { value: "INACTIVE" }, "INACTIVE", -1)
                      ]))], 512), [
                        [_vModelSelect, editForm.value.status]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_176, [
                      _createElementVNode("div", _hoisted_177, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editForm.value.trackBalance) = $event)),
                          class: "form-check-input",
                          type: "checkbox",
                          id: "trackBalanceCheck"
                        }, null, 512), [
                          [_vModelCheckbox, editForm.value.trackBalance]
                        ]),
                        _createElementVNode("label", _hoisted_178, _toDisplayString(_ctx.$t('merchants.track_balance')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_179, [
              _createElementVNode("button", _hoisted_180, _toDisplayString(_ctx.$t('merchants.cancel')), 1),
              _createElementVNode("button", {
                type: "submit",
                disabled: !btnLoadEdit.value || !selectedEditAccountCode.value,
                class: "btn text-white",
                style: {"background-color":"#EB9355"}
              }, [
                (!btnLoadEdit.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_182))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_183, _toDisplayString(_ctx.$t('merchants.save')), 1)
              ], 8, _hoisted_181)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_184, [
      _createElementVNode("div", _hoisted_185, [
        _createElementVNode("div", _hoisted_186, [
          _cache[38] || (_cache[38] = _createElementVNode("button", {
            type: "button",
            class: "btn-close status-modal-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1)),
          _createElementVNode("div", _hoisted_187, [
            _cache[36] || (_cache[36] = _createElementVNode("div", { class: "edit-status-icon" }, [
              _createElementVNode("i", { class: "flaticon-pen" })
            ], -1)),
            _createElementVNode("h5", _hoisted_188, _toDisplayString(_ctx.$t('merchants.change_status_title')), 1),
            _createElementVNode("p", _hoisted_189, _toDisplayString(currentOrgForStatus.value?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_190, [
            _createElementVNode("div", _hoisted_191, [
              _createElementVNode("label", _hoisted_192, _toDisplayString(_ctx.$t('merchants.account')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((selectedStatusAccountCode).value = $event)),
                class: "form-select fs-md-15 text-black shadow-none edit-status-select",
                onChange: onSelectStatusAccount
              }, [
                _createElementVNode("option", _hoisted_193, _toDisplayString(_ctx.$t('merchants.select_account')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusAccounts.value, (acc) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: acc.code,
                    key: acc.code
                  }, _toDisplayString(acc.merchantAccountType), 9, _hoisted_194))
                }), 128))
              ], 544), [
                [_vModelSelect, selectedStatusAccountCode.value]
              ])
            ]),
            (selectedStatusAccountCode.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                  _createElementVNode("label", _hoisted_196, _toDisplayString(_ctx.$t('merchants.status')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((newStatusValue).value = $event)),
                    class: "form-select fs-md-15 text-black shadow-none edit-status-select"
                  }, [...(_cache[37] || (_cache[37] = [
                    _createElementVNode("option", { value: "ACTIVE" }, "ACTIVE", -1),
                    _createElementVNode("option", { value: "INACTIVE" }, "INACTIVE", -1)
                  ]))], 512), [
                    [_vModelSelect, newStatusValue.value]
                  ])
                ]))
              : _createCommentVNode("", true),
            (statusError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_197, _toDisplayString(statusError.value), 1))
              : _createCommentVNode("", true)
          ]),
          (selectedStatusAccountCode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                _createElementVNode("button", _hoisted_199, _toDisplayString(_ctx.$t('merchants.cancel')), 1),
                _createElementVNode("button", {
                  type: "button",
                  disabled: !btnLoadStatus.value,
                  class: "btn edit-status-submit-btn",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (submitChangeStatus()))
                }, [
                  (!btnLoadStatus.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_201))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_202, _toDisplayString(_ctx.$t('merchants.validate')), 1)
                ], 8, _hoisted_200)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[39] || (_cache[39] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})